var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useEffect, useState, Fragment } from 'react';
import { Modal } from '@empiriecom/module-components';
import useIcon from '@empiriecom/module-components/utils/getIcon';
import { ThemeProvider, withTheme } from '@empiriecom/module-components/utils/styled-components';
import { Esi } from '@empiriecom/module-components/Esi';
import cuid from 'cuid';
import useConfig from '../hooks/useConfig';
import imgUrlPreparer from '../../utils/imgPreparer';
import { FeedbackWrapperOuther, FeedbackContainer, FeedbackContainerInner, FeedbackHeadline, FeedbackIconWrapper, FeedbackModalContainer, FeedbackModalListItem, FeedbackText, FeedbackWrapper, } from './styles';
import feedbackTeaserTheme from './theme';
export var FeedbackTeaserTestIds;
(function (FeedbackTeaserTestIds) {
    FeedbackTeaserTestIds["feedbackTeaserModalBoxContainer"] = "feedbackteaser-modalbox-container";
    FeedbackTeaserTestIds["feedbackTeaserModalBoxContentItems"] = "feedbackteaser-modalbox-items";
    FeedbackTeaserTestIds["feedbackTeaserComponent"] = "feedbackTeaser__component";
    FeedbackTeaserTestIds["feedbackTeaserInitialItem"] = "feedbackTeaserInitial__item";
    FeedbackTeaserTestIds["feedbackTeaserFeedbackItemContainer"] = "feedbackteaser-feedback-text";
    FeedbackTeaserTestIds["feedbackTeaserFeedbackItemHeadline"] = "feedbackteaser-feedback-text-headline";
    FeedbackTeaserTestIds["feedbackTeaserFeedbackItemContent"] = "feedbackteaser-feedback-text-text";
    FeedbackTeaserTestIds["feedbackTeaserFeedbackItemImage"] = "feedbackteaser-feedback-image";
    FeedbackTeaserTestIds["feedbackTeaserFeedbackItemImageSuccess"] = "feedbackteaser-feedback-image-success";
    FeedbackTeaserTestIds["feedbackTeaserModalBoxClose"] = "feedbackteaser-modal-close";
    FeedbackTeaserTestIds["feedbackTeaserModalBoxHeadline"] = "headline__component";
    FeedbackTeaserTestIds["feedbackTeaserModalBoxContent"] = "feedbackteaser-modal-content";
    FeedbackTeaserTestIds["feedbackTeaserModalBoxMoreContent"] = "feedbackteaser-modal-more-content";
})(FeedbackTeaserTestIds || (FeedbackTeaserTestIds = {}));
var emptyFeedbackTeaserData = {
    FeedbackTeaserRO: {
        bonusNumber: '',
        descriptionText: '',
        feebdackText: '',
        headline: '',
        id: '',
    },
};
var defaultModalBoxState = {
    isOpen: false,
};
var FeedbackTeaser = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    var contentData = _a.contentData, theme = _a.theme;
    var Checkmark = useIcon('Checkmark');
    var config = useConfig();
    var _m = useState(emptyFeedbackTeaserData), currentFeedbackData = _m[0], setFeedbackData = _m[1];
    var _o = useState({
        data: {
            AdditionalHeadline: '',
            AdditionalInformation: '',
            DisplayName: '',
            AdditionalText: '',
            CampaignHints: '',
            wasActive: false,
            success: false,
        },
        send: false,
        success: false,
    }), promotionPut = _o[0], setPromotionPut = _o[1];
    var _p = useState(defaultModalBoxState), modalBoxState = _p[0], setModalBoxState = _p[1];
    var campaignPutUrl = ((_c = (_b = config === null || config === void 0 ? void 0 : config.apiParams) === null || _b === void 0 ? void 0 : _b.values) === null || _c === void 0 ? void 0 : _c.apiCampaignEndPoint) || ''; // config?.apiParams?.values?.apiFeedbackTeaserEndpoint
    var feedbackInfoUrl = '/FeedBackTeaser'; // config?.apiParams?.values?.apiCampaignEndPoint
    useEffect(function () {
        var subscribedFeedback = true;
        if (subscribedFeedback) {
            fetch(feedbackInfoUrl)
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                .then(function (response) { return response.json(); })
                .then(function (json) {
                setFeedbackData(json);
                return json;
            })
                .catch(function () {
                return null;
            });
        }
        return function () {
            subscribedFeedback = false;
        };
    }, [feedbackInfoUrl]);
    var openModalBox = function () {
        var newModalBoxState = __assign({}, modalBoxState);
        newModalBoxState.isOpen = true;
        setModalBoxState(newModalBoxState);
    };
    var closeModalBox = function () {
        var newModalBoxState = __assign({}, modalBoxState);
        newModalBoxState.isOpen = false;
        setModalBoxState(newModalBoxState);
    };
    var urlNewsletter = ((_e = (_d = config === null || config === void 0 ? void 0 : config.esiUrls) === null || _d === void 0 ? void 0 : _d.values) === null || _e === void 0 ? void 0 : _e.homepageNlLayer) || null;
    var showModalBox = function () {
        return (React.createElement(Modal, { headline: promotionPut.data.AdditionalHeadline, onRequestClose: closeModalBox, open: modalBoxState.isOpen, testIdClose: FeedbackTeaserTestIds.feedbackTeaserModalBoxClose, testIdHeadline: FeedbackTeaserTestIds.feedbackTeaserModalBoxHeadline },
            React.createElement(FeedbackModalContainer, { "data-testid": FeedbackTeaserTestIds.feedbackTeaserModalBoxContainer },
                React.createElement(FeedbackModalListItem, { "data-testid": FeedbackTeaserTestIds.feedbackTeaserModalBoxContentItems }, promotionPut.data.DescriptionItems
                    ? promotionPut.data.DescriptionItems.map(function (item) { return (React.createElement("li", { key: cuid() }, item.content)); })
                    : ''),
                React.createElement("p", { "data-testid": FeedbackTeaserTestIds.feedbackTeaserModalBoxMoreContent }, promotionPut.data.CampaignHints)),
            React.createElement("div", { "data-testid": "cms-placeholder-newsletter-agnitas" }, urlNewsletter && React.createElement(Esi, { src: urlNewsletter }))));
    };
    var feedbackClickHandler = function () {
        fetch(campaignPutUrl + "?BonusNumber=" + contentData.field_bonus_number + "&json=true")
            .then(function (response) { return response.text(); })
            .then(function (text) {
            // cleanup invalid json
            var json = JSON.parse(text
                .replace(/("zur Kasse")/g, "'zur Kasse'")
                .replace(/\n/g, '')
                .replace(/(},],)/g, '}],'));
            if (json.success) {
                var newPromotionPutState = __assign({}, promotionPut);
                newPromotionPutState.send = true;
                newPromotionPutState.success = true;
                newPromotionPutState.data = json;
                setPromotionPut(newPromotionPutState);
                // nur wenn erfoglreich, dann soll die Feedback-API angesprochen werden
                return (fetch(feedbackInfoUrl, {
                    credentials: 'include',
                })
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    .then(function (response) { return response.json(); })
                    .then(function (responseJson) {
                    setFeedbackData(responseJson);
                    openModalBox();
                    return responseJson;
                }));
            }
            return json();
        })
            .catch(function () {
            // console.error('catch error', e);
            return undefined;
        });
    };
    var initalItem = (React.createElement("button", { "data-testid": FeedbackTeaserTestIds.feedbackTeaserInitialItem, onClick: feedbackClickHandler, type: "button" }, contentData.file &&
        contentData.file.map(function (item, index) {
            var _a, _b, _c, _d;
            var counter = "img " + index;
            var testId = FeedbackTeaserTestIds.feedbackTeaserFeedbackItemImage;
            var imageUrl = imgUrlPreparer(item.url || '', (_b = (_a = config === null || config === void 0 ? void 0 : config.apiCmsUrlPrefix) === null || _a === void 0 ? void 0 : _a.values) === null || _b === void 0 ? void 0 : _b.url);
            var opts = {};
            if (((_c = item === null || item === void 0 ? void 0 : item.data) === null || _c === void 0 ? void 0 : _c.alt) !== '') {
                // @ts-ignore
                opts.alt = item.data.alt;
            }
            if (((_d = item === null || item === void 0 ? void 0 : item.data) === null || _d === void 0 ? void 0 : _d.title) !== '') {
                // @ts-ignore
                opts.title = item.data.title;
            }
            if (item.field_name === 'field_feedback_image') {
                // eslint-disable-next-line react/jsx-props-no-spreading,jsx-a11y/alt-text
                return React.createElement("img", __assign({ "data-testid": testId, key: counter, src: imageUrl }, opts));
            }
            return React.createElement(Fragment, { key: counter });
        })));
    var feedbackImageSuccess = contentData.file &&
        contentData.file.find(function (item) { return item.field_name === 'field_feedback_image_success'; });
    var opts = {};
    if (((_f = feedbackImageSuccess === null || feedbackImageSuccess === void 0 ? void 0 : feedbackImageSuccess.data) === null || _f === void 0 ? void 0 : _f.alt) !== '') {
        // noinspection TypeScriptUnresolvedVariable
        // @ts-ignore
        opts.alt = (_g = feedbackImageSuccess === null || feedbackImageSuccess === void 0 ? void 0 : feedbackImageSuccess.data) === null || _g === void 0 ? void 0 : _g.alt;
    }
    if (((_h = feedbackImageSuccess === null || feedbackImageSuccess === void 0 ? void 0 : feedbackImageSuccess.data) === null || _h === void 0 ? void 0 : _h.title) !== '') {
        // noinspection TypeScriptUnresolvedVariable
        // @ts-ignore
        opts.title = (_j = feedbackImageSuccess === null || feedbackImageSuccess === void 0 ? void 0 : feedbackImageSuccess.data) === null || _j === void 0 ? void 0 : _j.title;
    }
    var imageUrl = imgUrlPreparer((feedbackImageSuccess === null || feedbackImageSuccess === void 0 ? void 0 : feedbackImageSuccess.url) || '', (_l = (_k = config === null || config === void 0 ? void 0 : config.apiCmsUrlPrefix) === null || _k === void 0 ? void 0 : _k.values) === null || _l === void 0 ? void 0 : _l.url);
    var testId = FeedbackTeaserTestIds.feedbackTeaserFeedbackItemImageSuccess;
    var feedbackTextItem = feedbackImageSuccess ? (
    // eslint-disable-next-line jsx-a11y/alt-text,react/jsx-props-no-spreading
    React.createElement("img", __assign({ "data-testid": testId, src: imageUrl }, opts))) : (React.createElement(FeedbackContainer, { className: "feedback-teaser", "data-testid": FeedbackTeaserTestIds.feedbackTeaserFeedbackItemContainer },
        React.createElement(FeedbackContainerInner, { key: "FCI1" },
            React.createElement(FeedbackIconWrapper, { key: "FI1" },
                React.createElement(Checkmark, { color: theme && theme.primary.color.normal, size: "3rem" })),
            React.createElement(FeedbackHeadline, { "data-testid": FeedbackTeaserTestIds.feedbackTeaserFeedbackItemHeadline, key: "FH1" }, currentFeedbackData.FeedbackTeaserRO.headline)),
        React.createElement(FeedbackContainerInner, { key: "FCI2" },
            React.createElement(FeedbackText, { "data-testid": FeedbackTeaserTestIds.feedbackTeaserFeedbackItemContent, key: "FT1" }, currentFeedbackData.FeedbackTeaserRO.feebdackText))));
    return (React.createElement(FeedbackWrapperOuther, { "data-testid": FeedbackTeaserTestIds.feedbackTeaserComponent },
        React.createElement(ThemeProvider, { theme: feedbackTeaserTheme },
            React.createElement(FeedbackWrapper, { key: "FW1" }, currentFeedbackData.FeedbackTeaserRO.bonusNumber ? feedbackTextItem : initalItem)),
        showModalBox()));
};
export default withTheme(FeedbackTeaser);
//# sourceMappingURL=index.js.map